import { isValidFileName } from "../../../../../common/utils/isValidFileName";
import { uploadFileToBase64String } from "../../../../../common/utils/utils";
import { IUpdateAuditoresUseCase } from "../../../presentation/useCases/update/update_auditores_servicos_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";

export class UpdateAuditoresUseCase implements IUpdateAuditoresUseCase {
  constructor(private readonly repository: IAuditorRepository) {}

  async updateAuditor(
    IdAuditor: number,
    Nome: string | null,
    TelFixo: string | null,
    TelCelular: string | null,
    Email: string | null,
    OutrasInformacoes: string | null,
    Cidade: string | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    Arquivo3: File | null,
    Arquivo4: File | null,
    Arquivo5: File | null,
    limparArquivo1: boolean,
    limparArquivo2: boolean,
    limparArquivo3: boolean,
    limparArquivo4: boolean,
    limparArquivo5: boolean,
    TipoAuditor: number
  ): Promise<void> {
    const arquivoNome1 = Arquivo1 !== null ? Arquivo1.name : null;

    const arquivoNome2 = Arquivo2 !== null ? Arquivo2.name : null;

    const arquivoNome3 = Arquivo3 !== null ? Arquivo3.name : null;

    const arquivoNome4 = Arquivo4 !== null ? Arquivo4.name : null;

    const arquivoNome5 = Arquivo5 !== null ? Arquivo5.name : null;

    await this.repository.updateAuditor(
      IdAuditor,
      Nome,
      TelFixo,
      TelCelular,
      Email,
      OutrasInformacoes,
      Cidade,
      Arquivo1,
      Arquivo2,
      Arquivo3,
      Arquivo4,
      Arquivo5,
      arquivoNome1,
      arquivoNome2,
      arquivoNome3,
      arquivoNome4,
      arquivoNome5,
      limparArquivo1,
      limparArquivo2,
      limparArquivo3,
      limparArquivo4,
      limparArquivo5,
      TipoAuditor
    );
  }
}
